import { useContext } from "react";
import { I18nContext } from "./I18nProvider";
import type { I18nContextValue } from "./types";

/**
 * Hook to access translation functionality and language state
 *
 * @returns The i18n context value with translation function and language controls
 * @throws Error if used outside of I18nProvider
 *
 * @example
 * function MyComponent() {
 *   const { t, language, setLanguage } = useTranslation();
 *
 *   return (
 *     <div>
 *       <p>{t("common.buttons.continue")}</p>
 *       <button onClick={() => setLanguage("en")}>English</button>
 *     </div>
 *   );
 * }
 */
export function useTranslation(): I18nContextValue {
  const context = useContext(I18nContext);

  if (!context) {
    throw new Error("useTranslation must be used within an I18nProvider");
  }

  return context;
}
